<template>
    <div class="bottom"> 
        <div class="container">
            <!-- 左侧：Logo + 联系信息合并区域 -->
            <div class="left-section">
                <div class="logo">
                    <img :src="logoURl" alt="中国电机工程学会">
                </div>
                <div class="contact-info" :style="textInlineStyle" v-html="textHtml"></div>
            </div>
            
            <!-- 右侧：二维码区域 -->
            <div class="qr-section">
                <div class="qr-code">
                    <img :src="qrUrl" alt="关注公众号">
                </div>
                <div class="qr-text">关注公众号</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'bottom',
    data() {
        return {
            logoURl: '',
            qrUrl: '',
            // qrCaption: ''
            textHtml: '',
            textInlineStyle: {}
        }
    },
    computed: {
        ...mapState(['bottomData'])
    },
    mounted() {
        console.log('[bottom] mounted bottomData:', this.bottomData)
        // 立即处理一次 bottomData
        this.processBottomData(this.bottomData)
        
        // 如果 bottomData 为空，主动获取首页数据
        if (!this.bottomData) {
            console.log('[bottom] bottomData 为空，主动获取首页数据')
            this.fetchHomePageData()
        }
    },
    watch: {
        bottomData: {
            immediate: true,
            handler(newVal, oldVal) {
                // console.log('[bottom] bottomData changed:', { newVal, oldVal })
                this.processBottomData(newVal)
            }
        }
    },
    methods: {
        formatPx(val) {
            if (val === undefined || val === null || val === '') return undefined
            const s = String(val)
            return /px$/.test(s) ? s : `${s}px`
        },
        processBottomData(bottomData) {
            if (!bottomData) {
                console.log('[bottom] bottomData 为空，使用默认值')
                return
            }
            
            this.logoURl = bottomData?.content?.mix?.sources[0]?.image.cn.url || ''
            this.qrUrl = bottomData?.content?.mix?.sources[2]?.image.cn.url || ''
            
            const textSource = bottomData?.content?.mix?.sources?.[1] || {}
            this.textHtml = textSource?.text?.cn?.content || ''
            const st = textSource?.style || {}
            this.textInlineStyle = {
                paddingLeft: this.formatPx(st.pl),
                paddingRight: this.formatPx(st.pr),
                paddingTop: this.formatPx(st.pt),
                paddingBottom: this.formatPx(st.pb),
                ...(st.background && st.background.color ? { background: st.background.color } : {})
            }
        },
        fetchHomePageData() {
            // 获取首页数据，提取底部模块
            this.$httpOw('get', `/x/${this.$store.state.showID}/static/page/1440.json`, {}, res => {
                console.log('[bottom] 获取首页数据成功:', res)
                if (res.status == 200) {
                    const blocks = (res.data && res.data.json && res.data.json.blocks) || []
                    const bottomBlock = blocks.find(b => b && b.name === '底部')
                    if (bottomBlock) {
                        // 更新 store 中的 bottomData
                        this.$store.commit('setBottomData', bottomBlock)
                        console.log('[bottom] 已设置 bottomData:', bottomBlock)
                    }
                }
            }, error => {
                console.error('[bottom] 获取首页数据失败:', error)
            })
        }
    }
}
</script>

<style scoped>
.bottom {
    width: 100%;
    height: auto;
    background: linear-gradient(to right, #156eeb 0%, #3cc3a1 100%);
    padding: 20px 0;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    padding: 1rem;
}

/* 左侧：Logo + 联系信息合并区域 */
.left-section {
    flex: 1;
    display: flex;
    align-items: center;
    margin-left: 5%;
}

/* Logo 限制框 */
.logo {
    width: 260px;
    height: 130px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background: white; */
    border-radius: 8px;
}

.logo img {
    height: 100%;
    width: auto;
    margin-right: 8%;
}

.contact-info {
    text-align: left;
    margin-left: 20px;
    color: white;
    font-size: 22px;
    line-height: 1.6;
    margin-bottom: 5px;
}

.contact-item {
    color: white;
    font-size: 22px;
    line-height: 1.6;
    margin-bottom: 5px;
}

/* 右侧：二维码 */
.qr-section {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.qr-code {
    background: white;
    border-radius: 8px;
    margin-bottom: 8px;
}

.qr-code img {
    width: 180px;
    height: 180px;
    display: block;
}

.qr-text {
    color: white;
    font-size: 20px;
    text-align: center;
}

/* 响应式设计 - 移动端 */
@media (max-width: 768px) {
    .container {
        flex-direction: row;
        align-items: flex-start;
        gap: 15px;
        padding: 1rem 0.5rem;
    }
    
    /* 左侧：Logo + 联系信息垂直排列 */
    .left-section {
        flex: 1;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 0;
        margin-left: 10px;
    }
    
    /* 移动端 Logo 限制框尺寸 */
    .logo {
        width: 150px;
        height: 70px;
        margin-bottom: 10px;
    }
    
    .logo img {
        height: 100%;
        width: auto;
        margin-right: 0;
        margin-bottom: 0;
    }
    
    .contact-info {
        text-align: left;
        margin-left: 0px;
        color: white;
        font-size: 14px;
        line-height: 1.4;
        margin-bottom: 3px;
    }
    
    .contact-item {
        font-size: 14px;
        line-height: 1.4;
        margin-bottom: 3px;
    }
    
    /* 右侧：二维码 */
    .qr-section {
        flex: 0 0 auto;
        align-items: center;
    }
    
    .qr-code img {
        width: 120px;
        height: 120px;
    }
    
    .qr-text {
        font-size: 14px;
    }
}
</style>
